app.service('CmsAccountModel', [
    'WS',
    '$state',
    '$location',
    '$rootScope',
    function (WS, $state, $location, $rootScope) {

        var model = this,
            URLS = {
                getUserDetails: 'cms/getUserDetails',
            };

        $rootScope.$on('successfulSignIn', function () {
            model.isUserLoggedIn = true;
        });

        model.refreshCmsAccountDetails = async () => {
            const response = await model.getUserDetails();
            if (response != null && response.responseStatus === "SUCCESS") {
                model.cmsAccountDetails = response;
            }
            return response;
        };

        $rootScope.roles = {
            ADMIN: 0,
            CMS_ADMIN: 10,
            CMS_MARKETING: 12,
            CMS_READ_ONLY: 14,
            USER: 30,
            CST_READ_ONLY: 43
        };

        $rootScope.hasAccess = model.hasAccess = function (minimumSectionRole) {
            if (model.cmsAccountDetails != null) {
                var myRole = $rootScope.roles[model.cmsAccountDetails.userRole];
                return myRole <= minimumSectionRole;
            } else {
                return false;
            }
        };

        model.getUserDetails = function () {
            return WS.callServer('cms/getUserDetails', {});
        };

    }]);